import React from 'react'

import './videoTag.scss'
export default function (props) {
    return (
        <div/>
    )
}